import React from 'react';
import { Drawer } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import type { ReferenceCardLocationState } from '../../types/referenceCardNavigation';

const drawerWidth = () => {
  if (typeof window === 'undefined') return 1120;
  return Math.min(1120, Math.floor(window.innerWidth * 0.95));
};

/**
 * Оборачивает карточку справочника: при открытии с backgroundLocation в state — в правом drawer.
 * Прямой заход по URL без state — дочерний контент без обёртки.
 */
export const EntityCardOverlayFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const loc = useLocation();
  const navigate = useNavigate();
  const state = loc.state as ReferenceCardLocationState | null;
  const isOverlay = Boolean(state?.backgroundLocation);

  if (!isOverlay) {
    return <>{children}</>;
  }

  return (
    <Drawer
      open
      placement="right"
      width={drawerWidth()}
      onClose={() => navigate(-1)}
      maskClosable
      destroyOnClose
      styles={{ body: { paddingTop: 8 } }}
      zIndex={1010}
    >
      {children}
    </Drawer>
  );
};
